import { StandaloneQuotebox } from 'base/components/Quotebox';

export const SvenskdamStandaloneQuotebox: typeof StandaloneQuotebox = ({ ...props }) => {
  props.author = undefined;
  return <StandaloneQuotebox {...props} />;
};
